import { Grid, Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Button, CustomTooltip } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { getPriceFormat } from 'lib/utils'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { gameMetaData, Order } from 'shared'

export interface OrderInfoProps {
  order: Order
}

export const OrderInfo = ({ order }: OrderInfoProps): JSX.Element => {
  const { t } = useTranslation()
  const { user } = useUser()
  t

  const [open, setOpen] = useState(false)

  const handleClose = (event: any) => {
    event
    setOpen(false)
  }

  const copyToClipboard = async () => {
    const address = [
      order.shipping?.name || '',
      order.shipping?.extra || '',
      order.shipping?.street || '',
      `${order.shipping?.zip || ''} ${order.shipping?.city || ''}`,
      order.shipping?.country || '',
    ]
      .filter((line) => line.trim() !== '')
      .join('\n')

    try {
      await navigator.clipboard.writeText(address)
      setOpen(true)
    } catch (err) {
      console.error('Error in clipboard copy ', err)
    }
  }

  const openShipmentPage = (order: Order) => {
    const rawGame: any = order.articleGames?.[0]
    const game = gameMetaData.find((entry) => {
      if (rawGame === 0 || rawGame === 'Unknown') return entry.name === 'Magic'
      return rawGame !== undefined ? entry.name === rawGame : entry.name === 'Magic'
    })
    const gameName = game?.cardmarketName ?? game?.name ?? 'Magic'
    window.open(
      `https://www.cardmarket.com/${user.language}/${gameName}/Orders/${order.sourceOrderId}`,
      '_blank'
    )
  }

  return (
    <div className="order-info">
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleClose} severity="success">
          Address copied to clipboard!
        </Alert>
      </Snackbar>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <div className="h-100 d-flex flex-column justify-content-between">
            <div>
              <h6 className="order-info-title">Order summary</h6>
              <span>
                Total items: <b>{order.articlesCount}</b>
              </span>
              <br />
              <span>
                Total value: <b>{getPriceFormat(order.totalValue, order.currency)}</b>
              </span>
            </div>
            <Button
              disabled={order.source !== 'cardmarket'}
              variant="contained"
              onClick={() => openShipmentPage(order)}
            >
              View Shipping Label
            </Button>
          </div>
        </Grid>

        <Grid item xs={12} sm={6} md={3} className="text-wrap">
          <h6 className="order-info-title">Buyer</h6>
          <span>{order.buyer?.address?.name}</span>
          <br />
          <span>[{order.buyer?.username}]</span>
          <br />
          <span>{order.buyer?.email}</span>
          <br />
          <span>{order.buyer?.phone}</span>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <div className="d-flex flex-row align-items-start">
            <h6 className="order-info-title">Shipping address</h6>
            <CustomTooltip title={'Copy address'}>
              <i className="fa-light fa-copy table-action-icon" onClick={copyToClipboard}></i>
            </CustomTooltip>
          </div>
          <span>{order.shipping?.name}</span>
          <br />
          <span>{order.shipping?.extra}</span>
          <br />
          <span>{order.shipping?.street}</span>
          <br />
          <span>
            {order.shipping?.zip}, {order.shipping?.city}
          </span>
          <br />
          <span>{order.shipping?.country}</span>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <h6 className="order-info-title">Shipping method</h6>
          <span>{order.shipping?.carrier?.replace('&lt;', '< ')}</span> <br />
          <span>Is letter: {t(`common.${order.shipping?.isLetter}`)}</span>
          <br />
          <span>Is insured: {order.shipping?.isInsured ? t('common.yes') : t('common.no')}</span>
          <br />
          <span>
            Tracking number: {order.shipping?.tracking ? order.shipping?.tracking : 'not available'}
          </span>
        </Grid>
      </Grid>
    </div>
  )
}
